module.exports = __webpack_public_path__ + "img/wxpay.0ecc0bde.png";